// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="overview">Overview</h2>
      <p>Our goal is to make easier and more secure for VSOs and other organizations to interact with the VA on behalf of Veterans. Individual API documentation is available above.</p>
    </div>
  );
};

export default MarkdownComponent;
